module.exports = __webpack_public_path__ + "img/c00_buildingtechmarksmanship_Normal_ua.cc0a62fb.webp";